<template>
    <div class="max-w-2xl mx-auto p-4">
        <h1 class="text-2xl font-semibold text-theme-base mb-6">
            Métodos de pago del portal
        </h1>

        <div class="flex flex-col gap-6">
            <div class="bg-theme-card rounded-xl p-6 flex flex-col gap-4">
                <section>
                    <h2 class="text-lg font-medium text-theme-base mb-2">
                        Ventas y órdenes internas
                    </h2>
                    <p class="text-sm text-theme-muted mb-4">
                        Selecciona los métodos de pago disponibles al registrar
                        órdenes internas desde este portal. Solo estos
                        aparecerán en la pantalla de nueva orden. No afecta los
                        métodos de pago del ecommerce, que se configuran por
                        separado.
                    </p>

                    <div class="grid grid-cols-2 md:grid-cols-3 gap-3">
                        <button
                            v-for="pm in allPaymentMethodOptions"
                            :key="pm.id"
                            class="rounded-xl p-3 text-left transition border-2"
                            :class="
                                form.portalPaymentMethodsAvailable.includes(
                                    pm.id
                                )
                                    ? 'border-brand-red bg-theme-card'
                                    : 'border-theme-border bg-theme-card hover:border-brand-red'
                            "
                            @click="togglePaymentMethod(pm.id)"
                        >
                            <div
                                class="font-semibold text-sm text-theme-base leading-tight"
                            >
                                {{ pm.label }}
                            </div>
                        </button>
                    </div>

                    <p
                        v-if="
                            validationTouched &&
                            !form.portalPaymentMethodsAvailable.length
                        "
                        class="text-theme-danger text-sm mt-3"
                    >
                        Selecciona al menos un método de pago
                    </p>
                </section>
            </div>

            <div class="rounded-xl p-6 flex justify-center">
                <app-button size="large" :loading="isLoading" @click="save">
                    Actualizar
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { paymentMethodsMerchant } from "@/common/fields/orders-payment-methods";

export default {
    name: "PaymentMethodsSettingsPage",
    layout: "app",
    data: () => ({
        isLoading: false,
        validationTouched: false,
        allPaymentMethodOptions: Object.entries(paymentMethodsMerchant).map(
            ([id, label]) => ({ id, label })
        ),
        form: {
            portalPaymentMethodsAvailable: []
        }
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (
            !(await verifyPagePermission(
                "tenant:GetPaymentMethodsSettings",
                "/app"
            ))
        )
            return;
        await this.loadSettings();
    },
    methods: {
        ...mapActions("tenants", [
            "getTenantPaymentMethodsSettings",
            "updateTenantPaymentMethodsSettings"
        ]),
        async loadSettings() {
            this.$loading.show();
            try {
                const data = await this.getTenantPaymentMethodsSettings();
                this.form.portalPaymentMethodsAvailable = Array.isArray(
                    data.portalPaymentMethodsAvailable
                )
                    ? [...data.portalPaymentMethodsAvailable]
                    : [];
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        togglePaymentMethod(id) {
            if (this.form.portalPaymentMethodsAvailable.includes(id)) {
                if (this.form.portalPaymentMethodsAvailable.length === 1) {
                    this.validationTouched = true;
                    return;
                }
                this.form.portalPaymentMethodsAvailable =
                    this.form.portalPaymentMethodsAvailable.filter(
                        (m) => m !== id
                    );
            } else {
                this.form.portalPaymentMethodsAvailable.push(id);
            }
        },
        async save() {
            this.validationTouched = true;
            if (!this.form.portalPaymentMethodsAvailable.length) return;

            this.isLoading = true;
            try {
                await this.updateTenantPaymentMethodsSettings({
                    portalPaymentMethodsAvailable: [
                        ...this.form.portalPaymentMethodsAvailable
                    ]
                });
                this.$toast.success({
                    title: "Configuración actualizada",
                    text: "Los métodos de pago han sido guardados."
                });
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
